import {PublisherData} from './PublisherDashboard';
import ReactEcharts from 'echarts-for-react';

interface Props {
    pubDat: PublisherData[],
    style: {}
}

const PublisherDoughnutChart = (props: Props) => {

    const impData = props.pubDat.reduce(function(result: any[], pData) {
        if (pData.name) {
            result.push({value: pData.impression, name: pData.name});
        }
        return result;
    }, []);

    const winData = props.pubDat.reduce(function(result: any[], pData) {
        if (pData.name) {
            result.push({value: pData.win, name: pData.name});
        }
        return result;
    }, []);

    const labelData = props.pubDat.reduce(function(result: any[], pData) {
        if (pData.name) {
            result.push(pData.name);
        }
        return result;
    }, []);

    const option = {
        title: {
            text: 'Wins and Impressions count',
            subtext: 'by Dsp',
            // textStyle: {fontSize: 'auto'},
            left: 'left'
        },
        tooltip: {
            trigger: 'item'
        },
        legend: {
            type: 'scroll',
            orient: 'vertical',
            right: 10,
            top: 20,
            bottom: 20,
            data: labelData
        },
        series: [
            {
                name: 'Wins',
                type: 'pie',
                radius: ['40%', '50%'],
                center: ['40%', '50%'],
                avoidLabelOverlap: false,
                label: {
                    formatter: '{b}\n{c}\n({d}%)',
                },
                data: winData
            },
            {
                name: 'Impressions',
                type: 'pie',
                radius: ['0%', '35%'],
                center: ['40%', '50%'],
                avoidLabelOverlap: false,
                label: {
                    formatter: '{b}\n{c}\n({d}%)',
                    position: 'inside'
                },
                data: impData
            }
        ]
    }

    return <ReactEcharts style={{margin: '10px 10px 10px 10px', ...props.style}} option={option}/>
}

export default PublisherDoughnutChart
